import { Mesh, BoxGeometry, Group, MeshBasicMaterial, EdgesGeometry, LineBasicMaterial, LineSegments } from 'three';

export default class Zone {
    constructor(GAME, zone_config) {
        this.GAME = GAME;
        this.zone_config = zone_config;
        this.init();
    }

    init() {

        this.group = new Group();

        this.material = new MeshBasicMaterial({
            color: '#ffffff',
            transparent: true,
            opacity: 0.2
        });

        this.selected_material = new MeshBasicMaterial({
            color: '#357EC0',
            transparent: true,
            opacity: 0.8
        });

        this.box = new Mesh(
            new BoxGeometry(this.zone_config.width, this.zone_config.height, this.zone_config.depth),
            this.material
        );

        this.box.name = this.zone_config.id;
        this.group.add(this.box);

        const edges = new EdgesGeometry(this.box.geometry);
        const lineMaterial = new LineBasicMaterial({ color: 0xebebeb, linewidth: 8 });
        this.outline = new LineSegments(edges, lineMaterial);
        this.group.add(this.outline);

        this.group.position.set(
            this.zone_config.position.x,
            this.zone_config.position.y,
            this.zone_config.position.z
        );

        this.GAME.scene.add(this.group);
    }

}